import React from 'react'

const Button = ({name}) => {
  return (
    <button className='bg-gray-200 px-3 py-1 m-2 rounded-lg'>{name}</button>
  )
}

export default Button